import { Image, get_prop } from 'utils'
import { Animation } from 'animation'
import { action, clear_action, live } from 'actions'

const BALLS = 90

// KEY CODES:
const ENTER = 13;
const ESC   = 27;
const SPACE = 32;
const KEY_1 = 49;
const F1    = 112;
const F2    = 113;
const F3    = 114;
const F4    = 115;
const F5    = 116;
const F6    = 117;
const F7    = 118;
const F8    = 119;
const F9    = 120;
const F10   = 121;

const COMB_WINS = [ 1500, 750, 500, 200, 100, 100, 100, 100, 100, 40, 40, 10, 10, 8, 3, 3, 3, 3, 3 ]

export default function( space, container ) {
    container.addChild( Image( 'res/mainfon.png' ) )
    
    //combinations bet:
    
    const price_combination_white = []
    const price_combination_red = []
    for ( let i = 0; i < 12; ++ i ) {
        const white = new PIXI.extras.BitmapText( '', { font : 'price_combination_white', align: "center" } )
        white.position.set( 35, 109 + i * 43 )
        white.anchor.x = 0.5
        container.addChild( white )
        price_combination_white.push( white )
        
        const red = new PIXI.extras.BitmapText( '', { font : 'price_combination_red', align: "center" } )
        red.visible = false
        red.position.set( 35, 109 + i * 43 )
        red.anchor.x = 0.5
        container.addChild( red )
        price_combination_red.push( red )
    }
    space.s( 'bet' ).on( bet => {
        const table_coefs = price_coefs_to_tables( COMB_WINS )
        for ( let i = 0; i < table_coefs.length; ++ i ) {
            price_combination_red[ i ].text = price_combination_white[ i ].text = ( table_coefs[ i ] * bet.value ).toString()
        }
    })
    //highlighted red boxes and win coefs:
    const blinking = []
    const cells = []
    let blinking_seconds
    const BLINKING_PERIOD = 0.400
    const red_cells_container = new PIXI.Container
    container.addChild( red_cells_container )
    space.s( 'bingo:rolled_field' )
        .with( space.s( 'net' ), ( field, net ) => ({ field, net }) )
        .on( ({ field, net }) => {
            //can't have any additional balls - no need to highlight I suppose:
            if ( ! net.actions.includes( 'doNext' ) ) {
                for ( const b of blinking ) b.visible = false
                blinking.length = 0
                for ( const c of cells ) c.destroy( { children : true } )
                cells.length = 0
                return
            }
            
            blinking_seconds = BLINKING_PERIOD
            for ( const card of field.possibleWinCombinations ) {
                for ( let symbol_i = 0; symbol_i < card.length; ++ symbol_i ) {
                    for ( let comb_i = 0; comb_i < card[ symbol_i ].length; ++ comb_i ) {
                        if ( card[ symbol_i ][ comb_i ] == 1 ) {
                            const cell = Image( 'res/second_display/cell.png' )
                            cells.push( cell )
                            blinking.push( cell )
                            const table_index = LINE_INDEX_TO_TABLE_INDEX[ comb_i ]
                            cell.position.set( 11 + symbol_i % 5 * 10, 82 + table_index * 43 + Math.floor( symbol_i / 5 ) * 10 )
                            red_cells_container.addChild( cell )
                            price_combination_red[ table_index ].visible = true
                            blinking.push( price_combination_red[ table_index ] )
                        }
                    }
                }
            }
        })
    space.s( 'ticker' ).on( s => {
        blinking_seconds -= s
        if ( blinking_seconds < - BLINKING_PERIOD ) blinking_seconds = BLINKING_PERIOD
        for ( const b of blinking ) b.visible = blinking_seconds >= 0
    })
    
    //big tube:
    const TUBE_FRAMES = 10
    const animationBigTube = Animation.byFrameName( 'res/tube_big/%03d.png', TUBE_FRAMES )
    animationBigTube.loop = true
    animationBigTube.position.set( 652, 29 )
    container.addChild( animationBigTube )
    //small tube:
    const animationLittleTube = Animation.byFrameName( 'res/tube_little/%03d.png', TUBE_FRAMES )
    animationLittleTube.loop = true
    animationLittleTube.position.set( 534, 46 )
    container.addChild( animationLittleTube )
    const TUBE_FRAME = 0.12
    let tube_seconds = 0
    space.s( 'ticker' )
        .with( space.s( 'bingo:rolling' ), space.s( 'bingo:speed' ), ( s, r, speed ) => ({ s, r, speed }) )
        .on( ({ s, r, speed }) => {
            let playing = false
            for ( const b of r ) {
                if ( b.waiting > 0 ) {
                    playing = true
                    break
                }
            }
            
            if ( playing ) {
                tube_seconds += s * speed
                while ( tube_seconds >= TUBE_FRAME ) {
                    tube_seconds -= TUBE_FRAME
                    const frame = ( animationBigTube.currentFrame + 1 ) % TUBE_FRAMES
                    animationBigTube.gotoAndStop( frame )
                    animationLittleTube.gotoAndStop( frame )
                }
            }
        })
    //90 balls:
    const balls_container = new PIXI.Container
    container.addChild( balls_container )
    //glass:
    const pictureGlass = []
    for ( let i = 0; i < 3; ++ i ) {
        const p = Image( 'res/glass/%03d.png'.$( i ) )
        const pos = [ [ 660, 0 ], [ 657, 15 ], [ 408, 16 ] ][ i ]
        p.position.set( pos[ 0 ], pos[ 1 ] )
        container.addChild( p )
        pictureGlass.push( p )
    }
    //gun:
    const gun = Image( 'res/loto_gun.png' )
    gun.position.set( 387, 1 )
    container.addChild( gun )
    //big balls:
    const animationBigBalls = Animation.byFrameName( 'res/bigballs/%03d.png', 9 )
    animationBigBalls.visible = false
    animationBigBalls.position.set( 411, 27 )
    container.addChild( animationBigBalls )
    const txtBigBallBlack = new PIXI.extras.BitmapText( '', { font : 'bigball_black', align: "center" } )
    txtBigBallBlack.anchor.x = 0.5
    txtBigBallBlack.position.set( 455, 58 )
    container.addChild( txtBigBallBlack )
    const txtBigBallWhite = new PIXI.extras.BitmapText( '', { font : 'bigball_white', align: "center" } )
    txtBigBallWhite.anchor.x = 0.5
    txtBigBallWhite.position.set( 455, 58 )
    container.addChild( txtBigBallWhite )
    space.s( 'bingo:big_ball' ).on( number => {
        animationBigBalls.visible = false
        txtBigBallWhite.visible = false
        txtBigBallBlack.visible = false
        if ( number >= 0 ) {
            const big_number = number % 9
            animationBigBalls.visible = true
            animationBigBalls.gotoAndStop( big_number )
            
            let txt
            if ( [ 0, 3, 8 ].includes( big_number ) ) txt = txtBigBallWhite
            else txt = txtBigBallBlack
            txt.visible = true
            txt.text = ( number + 1 ).toString()
        }
    })
    //blocker:
    const BLOCKER_FRAMES = 5
    const animationBlocker = []
    for ( let i = 0; i < 4; ++ i ) {
        const a = Animation.byFrameName( 'res/blocker/%03d/'.$( i ) + '%03d.png', 5 )
        a.loop = false
        a.animationSpeed = Animation.speed_by_fps( 15 )
        const pos = [ [ 100, 273 ], [ 100, 212 ], [ 100, 150 ], [ 100, 87 ] ][ i ]
        a.position.set( pos[ 0 ], pos[ 1 ] )
        animationBlocker.push( a )
        container.addChild( a )
    }
    space.s( 'bingo:rolling' ).on( rolling => {
        for ( let ai in animationBlocker ) {
            let open = false
            for ( let ri = [ 0, 10, 20, 30, 35 ][ ai ]; ri < [ 10, 20, 30, 35, 40 ][ ai ]; ++ ri ) {
                if ( ! get_prop( rolling, [ ri, 'finish' ] ) ) {
                    open = true
                    break
                }
            }
            animationBlocker[ ai ].gotoAndStop( open ? 0 : BLOCKER_FRAMES - 1 )
        }
    } )
    const zadvijka = sounds.get( 'res/sound/zadvijka' )
    space.s( 'ticker' )
        .with( space.s( 'bingo:rolling' ), ( _, rolling ) => rolling )
        .filter( rolling => rolling )
        .on( rolling => {
            let finish = 0
            for ( const r of rolling ) if ( r.finish ) ++ finish
            
            function run_blocker( i, balls ) {
                if ( finish >= balls && ! animationBlocker[ i ].playing && animationBlocker[ i ].currentFrame == 0 ) {
                    animationBlocker[ i ].gotoAndPlay( 1 )
                    zadvijka.play()
                }
            }
            
            run_blocker( 0, 10 )
            run_blocker( 1, 20 )
            run_blocker( 2, 30 )
            run_blocker( 3, 35 )
        })
    //speed:
    const animationSpeed = Animation.byFrameName( 'res/speed/%03d.png', 25 )
    animationSpeed.position.set( 559, 66 )
    container.addChild( animationSpeed )
    space.s( 'bingo:speed' ).on( s => animationSpeed.gotoAndStop( s - 1 ) )
    const picAutoSpeed = Image( 'res/speed/auto.png' )
    picAutoSpeed.position.set( 573, 119 )
    container.addChild( picAutoSpeed )
    const picManualSpeed = Image( 'res/speed/auto.png' )
    picManualSpeed.position.set( 573, 119 )
    container.addChild( picManualSpeed )
    //foreground:
    const pictureForeground = Image( 'res/foreground.png' )
    pictureForeground.position.set( 87, 16 )
    container.addChild( pictureForeground )
    //collect:
    const animationTCollect = Animation.byFrameName( 'res/collect/%03d.png', 10 )
    animationTCollect.animationSpeed = Animation.speed_by_fps( 15 )
    animationTCollect.visible = false
    animationTCollect.loop = true
    animationTCollect.gotoAndPlay( 0 )
    animationTCollect.position.set( 69, 131 )
    container.addChild( animationTCollect )
    //balls price table:
    const picPriceExtraBall = Animation.byFrameName( 'res/price_balls/%03d.png', 2 )
    picPriceExtraBall.animationSpeed = Animation.speed_by_fps( 2 )
    picPriceExtraBall.visible = false
    picPriceExtraBall.loop = true
    picPriceExtraBall.gotoAndPlay( 0 )
    picPriceExtraBall.position.set( 412, 28 )
    container.addChild( picPriceExtraBall )
    const txtPriceExtraBall = new PIXI.extras.BitmapText( '', { font : 'price_eb', align: "center" } )
    txtPriceExtraBall.visible = false
    txtPriceExtraBall.anchor.x = 0.5
    txtPriceExtraBall.position.set( 458, 45 )
    container.addChild( txtPriceExtraBall )
    space.s( 'net' ).on( () => {
        picPriceExtraBall.visible = false
        txtPriceExtraBall.visible = false
    })
    space.s( 'bingo:rolled' )
        .filter( r => r )
        .with( space.s( 'net' ), ( _, net ) => net )
        .filter( net => net.actions.includes( 'doNext' ) )
        .on( net => {
            picPriceExtraBall.visible = true
            
            txtPriceExtraBall.visible = true
            txtPriceExtraBall.text = net.state.priceOfAddingNumber.toString()
        })
    
    //bet:
    const txtBet = new PIXI.extras.BitmapText( '', { font : 'bet', align: "center" } )
    txtBet.anchor.x = 0.5
    txtBet.position.set( 730, 431 )
    container.addChild( txtBet )
    space.s( 'bet' ).on( bet => txtBet.text = bet.value.toString() )
    const txtWin = new PIXI.extras.BitmapText( '', { font : 'win', align: "center" } )
    txtWin.anchor.x = 0.5
    txtWin.position.set( 730, 481 )
    container.addChild( txtWin )
    space.s( 'bingo:rolled' )
        .with( space.s( 'net' ), ( r, net ) => ({ r, net }) )
        .on( ({ r, net }) => txtWin.text = ( r && net && net.win ) ? net.win.value.toString() : '0' )
    const txtCredit = new PIXI.extras.BitmapText( '', { font : 'credit', align: "center" } )
    txtCredit.anchor.x = 0.5
    txtCredit.position.set( 730, 380 )
    container.addChild( txtCredit )
    space.s( 'balance_poll' ).on( balance => txtCredit.text = balance ? balance.value.toString() : '' )
    
    //attention:
    const animationIndicatorBigWin = Animation.byFrameName( 'res/attention/indicator/%03d.png', 10 )
    animationIndicatorBigWin.loop = true
    animationIndicatorBigWin.animationSpeed = Animation.speed_by_fps( 15 )
    animationIndicatorBigWin.position.set( 661, 545 )
    animationIndicatorBigWin.gotoAndPlay( 0 )
    container.addChild( animationIndicatorBigWin )
    
    //balls counter:
    const balls_counter = new PIXI.extras.BitmapText( '', { font : 'counter_balls', align: "left" } )
    balls_counter.position.set( 569, 12 )
    container.addChild( balls_counter )
    const extraballs_counter = new PIXI.extras.BitmapText( '', { font : 'counter_extraballs', align: "left" } )
    extraballs_counter.position.set( 569, 12 )
    container.addChild( extraballs_counter )
    space.s( 'ticker' )
        .with( space.s( 'bingo:rolling' ), ( _, r ) => r )
        .on( r => {
            let value = 0
            for ( const b of r ) if ( b.waiting <= 0 ) ++ value
            extraballs_counter.text = balls_counter.text = '%02d'.$( value )
            balls_counter.visible = value <= 30
            extraballs_counter.visible = value > 30
        })
    
    const cards_container = new PIXI.Container
    container.addChild( cards_container )
    cards( space, cards_container, blinking )
    
    keys( space )
    
    balls( space, balls_container )
    
    help( space, container )
}

function keys( space ) {
    function action( key, name ) {
        return space.s( 'keyboard' )
            .with( space.s( 'pending' ), space.s( 'net' ), space.s( 'ui:isHelp' ), ( k, p, net, h ) => ({ k, p, net, h }) )
            .filter( ({ k, p, net, h }) => k == key && ! p && ! h && ( net.actions && net.actions.includes( name ) ) )
    }
    
    action( F8, 'doStart' )
        .map( () => ({ name : 'doStart', param : { bet : 20, cards : 4 } }) )
        .to( space.s( 'server_action' ) )
    action( F2, 'doNext' )
        .with( space.s( 'bingo:rolling' ), ( _, rolling ) => rolling )
        .filter( rolling => ! rolling || rolling.every( r => r.finish ) )
        .with( space.s( 'net' ), ( _, net ) => net.local.model_hash )
        .map( model_hash => ({ name : 'doNext', param : ({ modelHash : model_hash }) }) )
        .to( space.s( 'server_action' ) )
    action( F8, 'doTake' )
        .with( space.s( 'bingo:rolling' ), ( _, rolling ) => rolling )
        .filter( rolling => ! rolling || rolling.every( r => r.finish ) )
        .map( () => ({ name : 'doTake' }) )
        .to( space.s( 'server_action' ) )
    
    //bet:
    action( F2, 'betSet' )
        .with( space.s( 'net' ), ( _, net ) => net )
        .map( net => ({ name : 'betSet', param : { bet : Math.max( net.bet.value - 1, 1 ), cards : net.cards } } ) )
        .to( space.s( 'server_action' ) )
    action( F3, 'betSet' )
        .with( space.s( 'net' ), ( _, net ) => net )
        .map( net => ({ name : 'betSet', param : { bet : Math.min( net.bet.value + 1, 100 ), cards : net.cards } } ) )
        .to( space.s( 'server_action' ) )
    action( F4, 'betSet' )
        .with( space.s( 'net' ), ( _, net ) => net )
        .map( net => ({ name : 'betSet', param : { bet : net.bet.value, cards : Math.max( net.cards - 1, 0 ) }} ) )
        .to( space.s( 'server_action' ) )
    action( F5, 'betSet' )
        .with( space.s( 'net' ), ( _, net ) => net )
        .map( net => ({ name : 'betSet', param : { bet : net.bet.value, cards : Math.min( net.cards + 1, 4 ) }} ) )
        .to( space.s( 'server_action' ) )
    
    //speed tune:
    const speed1 = sounds.get( 'res/sound/speed1' )
    const speed2 = sounds.get( 'res/sound/speed2' )
    const speed3 = sounds.get( 'res/sound/speed3' )
    const speed4 = sounds.get( 'res/sound/speed4' )
    const speed5 = sounds.get( 'res/sound/speed5' )
    space.s( 'keyboard' )
        .with( space.s( 'bingo:speed' ), ( k, s ) => ({
            s,
            new_s : k == F6 ? Math.max( 1, s - 1 ) : k == F7 ? Math.min( 25, s + 1 ) : s
        }) )
        .filter( ({ s, new_s }) => new_s != s )
        .map( ({ new_s }) => new_s )
        .do( s => {
            if ( s < 5 ) speed5.play()
            else if ( s < 10 ) speed4.play()
            else if ( s < 15 ) speed3.play()
            else if ( s < 20 ) speed2.play()
            else speed1.play()
        } )
        .to( space.s( 'bingo:speed' ) )
}

const RED_BLINKING = 0.400

function cards( space, container, blinking ) {
    const cs = []
    space.s( 'net' )
        //cards change only when you can start new game (need to avoid cards potential wins reset every 'doNext' actions):
        .filter( net => net.actions.includes( 'doStart' ) || cs.length < 1 )
        .map( net => get_prop( net, [ 'state', 'cards' ] ) )
        .filter( cards => cards )
        .do( cards => {
            for ( const c of cs ) c.view.destroy( { children : true } )
            cs.length = 0
            
            for ( let i = 0; i < cards.length; ++ i ) {
                const c = card( cards[ i ] )
                c.view.position.set( ... [ [ 92, 360 ], [ 92, 476 ], [ 369, 360 ], [ 369, 476 ] ][ i ] )
                container.addChild( c.view )
                cs.push( c )
                
                c.win.text = '0'
            }
        })
        .name( space, 'bingo:cards_change' )
    
    space.s( 'bet' )
        //.with() to just guarantee cards already set up when trying to apply bet:
        .with( space.s( 'bingo:cards_change' ), ( bet, _ ) => bet )
        .on( bet => {
            let frame = 0
            if ( bet.value > 50 ) frame = 3
            else if ( bet.value > 10 ) frame = 2
            else if ( bet.value > 3 ) frame = 1
            
            for ( const c of cs ) {
                c.bet_color.gotoAndStop( frame )
                c.bet.text = bet.value.toString()
            }
        })
    
    const blinking_action = action()
    space.s( 'ticker' ).on( s => live( blinking_action, s ) )
    //painting numbers black for hit balls:
    space.s( 'bingo:roll_in' )
        .any( space.s( 'bingo:rolling' ), ( _, rolling ) => rolling )
        .on( rolling => {
            clear_action( blinking_action )
            
            //restoring numbers states just in case (fixing potential blinking_action race conditions or else - it's pay-related information anyway):
            for ( const card of cs ) {
                for ( const number of card.numbers ) {
                    number.black_block.visible = false
                    number.white.visible = false
                    number.black.visible = true
                }
            }
            
            for ( const ri in rolling ) {
                const r = rolling[ ri ]
                if ( r.waiting <= 0 || r.finish ) {
                    for ( const card of cs ) {
                        for ( const number of card.numbers ) {
                            if ( number.number == r.number ) {
                                number.black_block.visible = true
                                number.white.visible = true
                                number.black.visible = false
                                
                                //blink several times if it's last additional ball:
                                if ( ri > 30 && ri == rolling.length - 1 ) {
                                    for ( let i = 0; i < 14; ++ i ) {
                                        blinking_action.push( { duration : 0.080 } )
                                        blinking_action.push( { callback : () => {
                                            number.black_block.visible = ! number.black_block.visible
                                            number.white.visible = ! number.white.visible
                                            number.black.visible = ! number.black.visible
                                        } } )
                                    }
                                }
                                
                                break
                            }
                        }
                    }
                }
            }
        })
    
    const WIN_LINES = [ [28,34],[29,36],[29,36],[29,35],[29,35],[29,35],[29,64],[29,35],[28,35],[78,35],[29,35],[29,35],[29,35],[25,35],[29,35],[29,35],[27,94],[27,65],[27,36] ]
    const POTENTIAL_WINS = [[30,36],[30,36],[30,36],[30,36],[30,36],[30,36],[30,65],[30,36],[29,36],
         [78,36],[30,36],[30,36],[30,36],[28,38],[30,36],[30,36],[28,95],[28,66],[28,37]]
    
    space.s( 'bingo:rolled' )
        .any( space.s( 'net' ), ( rolled, net ) => ({ rolled, net }) )
        .filter( ({ rolled, net }) => rolled && get_prop( net, [ 'state', 'field' ] ) )
        .map( ({ net }) => get_prop( net, [ 'state', 'field' ] ) )
        .name( space, 'bingo:rolled_field' )
    
    space.s( 'bingo:rolled_field' )
    .with( space.s( 'bet' ), space.s( 'net' ), ( field, bet, net ) => ({ field, bet, net }) )
    .on( ({ field, bet, net }) => {
        console.log( 'field:', field )
        
        for ( let i = 0; i < cs.length; ++ i ) {
            const card = cs[ i ]
            
            //card wins:
            card.win.text = field.winsByCard[ i ].toString()
            
            //win lines:
            if ( card.win_lines ) for ( const wl of card.win_lines ) wl.destroy( { children : true } )
            card.win_lines = []
            const combinationsByCard = field.combinationsByCard[ i ]
            for ( let wli = 0; wli < combinationsByCard.length; ++ wli ) {
                if ( combinationsByCard[ wli ] == 1 ) {
                    const win_line = Image( 'res/cards/lines/win/%03d.png'.$( wli ) )
                    win_line.position.set( WIN_LINES[ wli ][ 0 ], WIN_LINES[ wli ][ 1 ] )
                    card.view.addChild( win_line )
                    card.win_lines.push( win_line )
                }
            }
            
            //revert any previous blinkings:
            if ( card.potential_wins ) for ( const pw of card.potential_wins ) pw.destroy( { children : true } )
            card.potential_wins = []
            if ( card.potential_win_texts ) {
                for ( const pwt of card.potential_win_texts ) pwt.destroy( { children : true } )
                card.potential_win_texts.length = 0
            }
            for ( const number of card.numbers ) number.red_block.visible = false
            
            //no need to show potential wins when player can't add any new balls, I suppose:
            if ( net.actions.includes( 'doNext' ) ) {
                //temporarely store potential wins to get the most one per cell since we can display only one for every cell:
                const max_potential_wins = {}
                const possibleWinCombinations = field.possibleWinCombinations[ i ]
                for ( let symbol_i = 0; symbol_i < possibleWinCombinations.length; ++ symbol_i ) {
                    for ( let li = 0; li < possibleWinCombinations[ symbol_i ].length; ++ li ) {
                        if ( possibleWinCombinations[ symbol_i ][ li ] == 1 ) {
                            const potential_win = Image( 'res/cards/lines/will_be/%03d.png'.$( li ) )
                            potential_win.position.set( POTENTIAL_WINS[ li ][ 0 ], POTENTIAL_WINS[ li ][ 1 ] )
                            card.view.addChild( potential_win )
                            card.potential_wins.push( potential_win )
                            
                            blinking.push( card.numbers[ symbol_i ].red_block )
                            card.numbers[ symbol_i ].red_block.visible = true
                            
                            max_potential_wins[ symbol_i ] = Math.max( max_potential_wins[ symbol_i ] || 0, COMB_WINS[ li ] * bet.value )
                        }
                    }
                }
                for ( const pwi in max_potential_wins ) {
                    const potential_win_text = new PIXI.extras.BitmapText( max_potential_wins[ pwi ].toString(), { font : 'possible_win_cell', align: "right" } )
                    potential_win_text.position.set( 55 + pwi % 5 * 48 - 1, 40 + Math.floor( pwi / 5 ) * 29 - 1 )
                    potential_win_text.anchor.set( 1, 0 )
                    card.view.addChild( potential_win_text )
                    
                    if ( ! card.potential_win_texts ) card.potential_win_texts = []
                    card.potential_win_texts.push( potential_win_text )
                }
            }
        }
        
        //winning sound:
        let best_line = Number.MAX_SAFE_INTEGER
        for ( const card_comb of field.combinationsByCard ) {
            for ( let i = 0; i < card_comb.length; ++ i ) {
                if ( card_comb[ i ] == 1 && i < best_line ) best_line = i
            }
        }
        if ( best_line != Number.MAX_SAFE_INTEGER ) {
            if ( best_line == 0 ) sounds.get( 'res/sound/win/001' ).play()
            else if ( best_line == 1 ) sounds.get( 'res/sound/win/002' ).play()
            else if ( best_line < 4 ) sounds.get( 'res/sound/win/003' ).play()
            else if ( best_line < 9 ) sounds.get( 'res/sound/win/004' ).play()
            else sounds.get( 'res/sound/win/000' ).play()
        }
    })
}

function card( values ) {
    const view = Image( 'res/cards/table.png' )
    view.interactiveChildren = false
    
    const bet_color = Animation.byFrameName( 'res/cards/tabs/%03d.png', 4 )
    bet_color.position.set( 8, 3 )
    view.addChild( bet_color )
    
    const win = new PIXI.extras.BitmapText( '0', { font : 'card_betwin', align: "center" } )
    win.anchor.x = 0.5
    win.position.set( 210, 4 )
    view.addChild( win )
    
    const bet = new PIXI.extras.BitmapText( '', { font : 'card_betwin', align: "let" } )
    bet.position.set( 60, 4 )
    view.addChild( bet )
    
    const numbers = []
    for ( let i = 0; i < 15; ++ i ) {
        function block( index ) {
            const b = Image( 'res/cards/colour_blocks/%03d.png'.$( index ) )
            b.visible = false
            b.position.set( 8 + i % 5 * 48, 23 + Math.floor( i / 5 ) * 29 )
            view.addChild( b )
            return b
        }
        const red_block = block( 0 )
        const black_block = block( 1 )
        
        const white = new PIXI.extras.BitmapText( ( values[ i ] + 1 ).toString(), { font : 'card_cell_white', align: "center" } )
        white.anchor.x = 0.5
        white.visible = false
        view.addChild( white )
        
        const black = new PIXI.extras.BitmapText( ( values[ i ] + 1 ).toString(), { font : 'card_cell_black', align: "center" } )
        black.anchor.x = 0.5
        view.addChild( black )
        
        const x = 30 + i % 5 * 48
        const y = 28 + Math.floor( i / 5 ) * 29
        white.position.set( x, y )
        black.position.set( x, y )
        
        numbers.push({
            number : values[ i ],
            red_block,
            black_block,
            white,
            black,
        })
    }
    
    return {
        view,
        bet_color,
        bet,
        win,
        numbers,
    }
}

const coordsXYEndPosition =
[
    [574, 288],
    [521, 288],
    [468, 288],
    [415, 288],
    [362, 288],
    [309, 288],
    [256, 288],
    [203, 288],
    [150, 288],
    [97,  288],
    [574, 224],
    [521, 224],
    [468, 224],
    [415, 224],
    [362, 224],
    [309, 224],
    [256, 224],
    [203, 224],
    [150, 224],
    [97,  224],
    [574, 160],
    [521, 160],
    [468, 160],
    [415, 160],
    [362, 160],
    [309, 160],
    [256, 160],
    [203, 160],
    [150, 160],
    [97,  160],

    [309, 96],
    [256, 96],
    [203, 96],
    [150, 96],
    [97,  96],

    [97,  32],
    [150, 32],
    [203, 32],
    [256, 32],
    [309, 32],
]

const coordXYStartMoveLeftBall = [ 422, 32 ]
const coordXEndMoveLeftBall = 97
const coordYStart = 0
const coordYIntermediatePoint = 100
const coordYEndPoint = 285

const widthBall = 54
const hightBall = 54

/*const speedYDown  = 376
const speedMoveX  = 376*/
const SPEED = 376

const speedRotate = 900


function travel( pos, target, moved ) {
    if ( pos != target ) {
        let np
        if ( target > pos ) np = Math.min( target, pos + moved )
        else np = Math.max( target, pos - moved )
        return {
            pos : np,
            finish : target == pos,
            travelled : np - pos,
        }
    }
    return { pos : target, finish : true, travelled : 0 }
}

const BOTTLE = 0.640

function balls( space, container ) {
    space.s( 'bingo:speed' ).next( 1 )
    
    space.s( 'ticker' )
        .any( space.s( 'bingo:rolling' ), ( seconds, rolling ) => ({ seconds, rolling }) )
        .map( ({ seconds, rolling }) => {
            if ( ! rolling ) return -1
            let last
            for ( const r of rolling ) {
                if ( r.waiting <= 0 ) last = r
                else break
            }
            if ( ! last ) return -1
            if ( last.finish ) return -1
            return last.number
        })
        .to( space.s( 'bingo:big_ball' ) )
    
    const bump_sound = sounds.get( 'res/sound/ballt' )
    const roll_in_sound = sounds.get( 'res/sound/ballroll' )
    const add_in_sound = sounds.get( 'res/sound/out_extraball' )
    const free_in_sound = sounds.get( '')
    //server doesn't store any info on what was the cost of current additional ball:
    let free_ball_pending = false
    space.s( 'server_action' )
        .with( space.s( 'net' ), ( action, net ) => ({ action, net }) )
        .map( ({ action, net }) => action.name == 'doNext' && net.priceOfAddingNumber == 0 )
        .on( free => free_ball_pending = free )
    
    space.s( 'ticker' )
        .any( space.s( 'bingo:rolling' ), ( seconds, rolling ) => ({ seconds, rolling }) )
        .filter( ({ rolling }) => rolling )
        .with( space.s( 'bingo:speed' ), ( p, speed ) => { p.speed = speed; return p } )
        .on( ({ seconds, rolling, speed }) => {
            if ( ! ( seconds >= 0 ) ) seconds = 0
            seconds = Math.min( seconds, 1 / 20 )
            seconds *= speed
            
            for ( const ri in rolling )
            {
                const r = rolling[ ri ]
                r.image.visible = true
                //flying in inside glass bottle:
                if ( r.waiting > 0 ) {
                    r.waiting -= seconds
                    
                    const fraction = ( BOTTLE - r.waiting ) / BOTTLE
                    r.image.rotation = - Math.PI / 20 + ( Math.PI / 10 ) * fraction
                    r.image.position.set( 706 + 60 * r.rand, 320 * fraction )
                    
                    if ( r.waiting <= 0 ) {
                        seconds = - r.waiting
                        r.image.position.set( coordXYStartMoveLeftBall[ 0 ], coordXYStartMoveLeftBall[ 1 ] )
                        
                        const sound = ri > 30 ? ( ri == rolling.length - 1 && free_ball_pending ? free_in_sound : add_in_sound ) : roll_in_sound
                        sound.play()
                        
                        space.s( 'bingo:roll_in' ).next( r )
                    }
                    else continue
                }
                
                //moving:
                let travelled = 0
                let bumping = false
                if ( r.path && r.path.length > 0 ) {
                    bumping = true
                    const dest = r.path[ 0 ]
                    
                    const x = travel( r.image.position.x, dest[ 0 ], SPEED * seconds )
                    r.image.position.x = x.pos
                    
                    const y = travel( r.image.position.y, dest[ 1 ], SPEED * seconds )
                    r.image.position.y = y.pos
                    
                    if ( x.finish && y.finish ) r.path.shift()
                    
                    travelled = Math.abs( x.travelled ) > Math.abs( y.travelled ) ? x.travelled : y.travelled
                }
                
                if ( bumping && r.path.length < 1 ) bump_sound.play()
                
                //rotate to initial position:
                if ( ! r.path || r.path.length < 1 ) {
                    r.image.rotation = r.image.rotation % ( Math.PI * 2 )
                    if ( r.image.rotation == r.target_rotation || r.image.rotation == Math.PI * 2 + r.target_rotation ) r.finish = true
                    else {
                        const actual_rotation = Math.PI * 2 * seconds
                        if ( r.image.rotation < Math.PI ) r.image.rotation = Math.max( r.target_rotation, r.image.rotation - actual_rotation )
                        else r.image.rotation = Math.min( Math.PI * 2 + r.target_rotation, r.image.rotation + actual_rotation )
                    }
                }
                //rotate accordingly friction:
                else {
                    r.image.rotation = ( r.image.rotation + travelled / ( widthBall / 2 ) ) % ( Math.PI * 2 )
                }
            }
        })
    
    space.s( 'ticker' )
        .any( space.s( 'bingo:rolling' ), ( _, rolling ) => rolling )
        .map( rolling => {
            if ( ! rolling ) return false
            for ( const r of rolling ) if ( ! r.finish ) return false
            return true
        })
        .changed()
        .to( space.s( 'bingo:rolled' ) )
    
    space.s( 'net' )
        .filter( net => get_prop( net, [ 'state', 'field', 'numbers' ] ) )
        .with( space.s( 'bingo:rolling' ), ( net, rolling ) => ({ net, rolling }) )
        .do( ({ rolling }) => {
            if ( rolling ) {
                for ( const r of rolling ) r.image.destroy( { children : true } )
                rolling.length = 0
            }
        })
        .map( ({ net }) => {
            const numbers = net.state.field.numbers
            const add = net.state.field.numbersAdded
            const rolling = []
            for ( const b of numbers ) append_ball( container, rolling, b, undefined, add && add.length > 0 )
            if ( add ) for ( const bi in add ) append_ball( container, rolling, add[ bi ], undefined, bi != add.length - 1 )
            return rolling
        } )
        .to( space.s( 'bingo:rolling' ) )
}

function append_ball( container, balls, ball, waiting, finish ) {
    const image = Image( 'res/balls/%03d.png'.$( ball ) )
    image.anchor.set( 0.5 )
    image.visible = false
    container.addChild( image )
    
    const D = widthBall / 2
    
    let path = undefined
    if ( finish ) {
        image.position.set( coordsXYEndPosition[ balls.length ][ 0 ] + D, coordsXYEndPosition[ balls.length ][ 1 ] + D )
    }
    else {
        path = []
        //top left corner:
        if ( balls.length < 35 ) {
            path.push( [ coordXEndMoveLeftBall + D, coordXYStartMoveLeftBall[ 1 ] + D ] )
            let target
            if ( balls.length < 9 ) target = 288
            else if ( balls.length < 19 ) target = 224
            else if ( balls.length < 29 ) target = 160
            else if ( balls.length < 35 ) target = 96
            else target = 32
            path.push( [ coordXEndMoveLeftBall + D, target + D ] )
        }
        path.push( coordsXYEndPosition[ balls.length ].map( c => c + D ) )
    }
    
    const target_rotation = balls.length < 30 ? 0 : - Math.PI / 9
    //so that when balls are recovered at their final position rotation will be already set:
    image.rotation = target_rotation
    
    balls.push( {
        waiting : finish ? 0 : balls.length > 0 ? balls[ balls.length - 1 ].waiting + 0.320 : BOTTLE,
        image,
        number : ball,
        path,
        rand : Math.random(),
        finish,
        target_rotation,
    } )
}

function help( space, container ) {
    const view = new PIXI.Container
    view.visible = false
    container.addChild( view )
    const pages = []
    const PAGES = 2
    for ( let i = 0; i < PAGES; ++ i ) {
        const page = Image( 'res/help/%03d.png'.$( i ) )
        page.visible = false
        view.addChild( page )
        pages.push( page )
    }
    
    function visible_index() {
        let i = 0
        for ( const page of pages )  {
            if ( page.visible ) return i
            ++ i
        }
        return -1
    }
    function hide() {
        for ( const page of pages ) page.visible = false
    }
    function show( i ) {
        hide()
        pages[ i ].visible = true
        page_sound.play()
    }
    const page_sound = sounds.get( 'res/sound/shuffle' )
    //page left:
    space.s( 'keyboard' )
        .filter( k => k == F2 && view.visible && visible_index() > 0 )
        .on( () => show( visible_index() - 1 ) )
    //page right:
    space.s( 'keyboard' )
        .filter( k => k == F8 && view.visible && visible_index() < ( PAGES -1 ) )
        .on( () => show( visible_index() + 1 ) )
    
    const background_music = sounds.get( 'res/sound/hfon' )
    background_music.loop( true )
    space.s( 'keyboard' )
        .filter( k => k == F1 )
        .with( space.s( 'ui:isHelp' ), ( _, h ) => h )
        .filter( h => ! h )
        .on( () => {
            hide()
            pages[ 0 ].visible = true
            view.visible = true
            background_music.play()
            space.s( 'ui:isHelp' ).next( true )
        })
    space.s( 'keyboard' )
        .filter( k => k == ESC )
        .on( () => {
            view.visible = false
            background_music.stop()
            space.s( 'ui:isHelp' ).next( false )
        } )
}

const LINE_INDEX_TO_TABLE_INDEX = [ 0, 1, 2, 3, 4, 4, 4, 5, 5, 6, 7, 8, 8, 9, 10, 10, 11, 11, 11 ]

function price_coefs_to_tables( price )
{
    const r = []
    for ( let i = 0; i < price.length; ++ i ) r[ LINE_INDEX_TO_TABLE_INDEX[ i ] ] = price[ i ]
    return r
}








// WEBPACK FOOTER //
// ./src/game.es6